<div class="notification-container" data-testid="focus-notification-root">
  <div class="notification-header" data-testid="focus-notification-header-root">
    <div class="header-left">
      <span class="title" data-testid="focus-notification-title">Notifications</span>
      <span class="notification-count" data-testid="focus-notification-unread-count" *ngIf="notificationService.totalUnreadCount$ | async">{{ notificationService.totalUnreadCount$ | async }}</span>
    </div>
    <button class="mark-all-as-read" data-testid="focus-notification-markallasreadbtn-markallasread" (click)="markAllAsRead()" *ngIf="notifications.length > 0">Mark all as read</button>
  </div>

  <div class="notification-list" data-testid="focus-notification-list" [appLoading]="isLoading" >
    <div *ngIf="notifications.length === 0" class="no-notifications" data-testid="focus-notification-empty-root">
      <div class="col-sm-12"
            style="padding: 20px 15px; margin-bottom: 20px; text-align: center;">
          <img src="../../../../../assets/images/Upfront Icon/Empty1.svg" style="width: 80px;" />
          <p data-testid="focus-notification-empty-message" style="color: #75787B; font-size: 20px; margin-top: 20px;">
            No new notifications.
          </p>
        </div>
    </div>
    <div *ngFor="let notification of notifications" class="notification-item" data-testid="focus-notification-item" [class.read]="notification.read" [class.standard-notification-item]="notification.type !== 'task_note_tagged'" (click)="openMyConversation(notification)">
      <img [src]="notification.type === 'follow' ? '/assets/images/client-messaging/FollowerAdded.svg' :notification.user.avatar" alt="User Avatar" class="notification-avatar" data-testid="focus-notification-item-avatar">
      <div class="notification-content">
        <ng-container *ngIf="notification.type !== 'task_note_tagged'; else taskNoteTaggedTemplate">
          <div class="notification-meta">
            <span class="notification-user-name" data-testid="focus-notification-item-username-value">{{ notification.type === 'follow' ? 'Follow' : notification.user.name }}</span>
            <span class="notification-type" data-testid="focus-notification-item-type-incomingsms-value" *ngIf="notification.type === 'incoming_sms'">Incoming SMS</span>
            <span class="notification-type" data-testid="focus-notification-item-type-incomingemail-value" *ngIf="notification.type === 'incoming_email'">Incoming Email</span>
            <span class="notification-type" data-testid="focus-notification-item-type-follow-value" *ngIf="notification.type === 'follow'">Follower Added</span>
          </div>
          <p class="notification-message" data-testid="focus-notification-item-message-value" *ngIf="notification.message">
            <span *ngIf="notification.type === 'incoming_email'" class="font-medium">Subject: <span [innerHTML]="notification.subject && notification.subject.length > 22 ? (notification.subject | slice:0:22) + '...' : notification.subject "></span></span>
            <span class="message" [innerHTML]="notification.message.length > 60 ? (notification.message | slice:0:60) + '...' : notification.message"></span>
          </p>
          <div class="message attachment-preview" data-testid="focus-notification-item-attachment-value" *ngIf="notification.hasAttachment && !notification.message">
            <i class="fa fa-paperclip attachment-icon"></i>
            <span>Attachment</span>
          </div>
          <span class="notification-time" data-testid="focus-notification-item-time-value">
            <img src="/assets/images/client-messaging/time.svg" alt="Time icon" />
            {{ notification.timeAgo }}
          </span>
        </ng-container>

        <ng-template #taskNoteTaggedTemplate>
          <div class="task-note-tagged-header">
            <div class="notification-meta">
              <span class="notification-user-name" data-testid="focus-notification-item-tasknote-username-value">{{ notification.patientName || notification.user.name }}</span>
              <span class="notification-type" data-testid="focus-notification-item-type-tasknotetagged-value">Task Note Tagged</span>
            </div>
          </div>
          <p class="task-note-tagged-task" data-testid="focus-notification-item-tasknote-task-value" *ngIf="notification.taskNoteTaggedMeta?.taskName">
            Task: {{ notification.taskNoteTaggedMeta?.taskName }}
          </p>
          <p class="task-note-tagged-label" data-testid="focus-notification-item-tasknote-label">
            {{ (notification.taskNoteTaggedMeta?.username || 'Someone') | titlecase }} tagged you in a note:
          </p>
          <p class="task-note-tagged-note" data-testid="focus-notification-item-tasknote-note-value" *ngIf="notification.taskNoteTaggedMeta?.noteSnippet || notification.message"
            [title]="(notification.taskNoteTaggedMeta?.noteSnippet || notification.message) | followupMention:-1:true">
            "<span [innerHTML]="(notification.taskNoteTaggedMeta?.noteSnippet || notification.message) | followupMention"></span>"
          </p>
          <span class="task-note-tagged-queue" data-testid="focus-notification-item-tasknote-queue-value" *ngIf="notification.taskNoteTaggedMeta?.queueName">
            Queue: {{ notification.taskNoteTaggedMeta?.queueName }}
          </span>
          <span class="task-note-tagged-time" data-testid="focus-notification-item-tasknote-time-value">
            <img src="/assets/images/client-messaging/time.svg" alt="Time icon" />
            {{ notification.timeAgo }}
          </span>
        </ng-template>
      </div>
    </div>
  </div>

  <div class="notification-footer" data-testid="focus-notification-footer-root"  (click)="viewAllNotifications()">
    <button data-testid="focus-notification-viewallbtn-viewallnotifications">View all notifications</button>
  </div>
</div>